document.addEventListener('DOMContentLoaded', function () {

  // window.toggleSound = function(event, el) {
  //   event.stopPropagation();

  //   const videoMedia = el.closest('video-media');
  //   if (!videoMedia) return;

  //   const video = videoMedia.querySelector('video');
  //   if (!video) return;

  //   video.muted = !video.muted;

  //   if (video.muted) {
  //     el.classList.add('is-muted');
  //     el.classList.remove('is-unmuted');
  //   } else {
  //     el.classList.add('is-unmuted');
  //     el.classList.remove('is-muted');
  //   }
  //   const icon = video.closest('.dk-video-media')?.querySelector('.dk-sound-on-off');
  //   icon.classList.add("demo-classs");
  //    const slash = icon.querySelector('path:last-child');
  //     slash.classList.add('hidden');
  // };

  window.toggleSound = function(event, el) {
  // prevent parent click (like redirect)
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  const videoMedia = el.closest('video-media');
  if (!videoMedia) return;

  const video = videoMedia.querySelector('video');
  if (!video) return;

  const willUnmute = video.muted;

  // 🔇 Mute ALL videos first
  document.querySelectorAll('video-media video').forEach(v => {
    v.muted = true;

    const icon = v.closest('video-media')?.querySelector('.dk-sound-on-off');
    if (icon) {
      icon.classList.add('is-muted');
      icon.classList.remove('is-unmuted');
      icon.setAttribute('aria-label', 'Unmute');
      icon.setAttribute('title', 'Unmute');

      const slash = icon.querySelector('path:last-child');
      if (slash) slash.classList.remove('hidden'); // show slash when muted
    }
  });

  // 🎵 Toggle current video
  video.muted = !willUnmute;
  const muted = video.muted;

  // ensure video plays when unmuted (important for mobile)
  if (!muted && video.paused) {
    try { video.play(); } catch (e) {}
  }

  // toggle classes
  el.classList.toggle('is-muted', muted);
  el.classList.toggle('is-unmuted', !muted);

  // accessibility labels
  el.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
  el.setAttribute('title', muted ? 'Unmute' : 'Mute');

  // 🔄 toggle slash icon
  const slash = el.querySelector('path:last-child');
  if (slash) {
    if (muted) {
      slash.classList.remove('hidden'); // show when muted
    } else {
      slash.classList.add('hidden'); // hide when unmuted
    }
  }


};


document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".dk-video-list-wrapper");
  const slider = document.querySelector(".dk-video-list-grid");
  if (!wrapper || !slider) return;

  function updateLayout() {
    if (slider.scrollWidth > wrapper.clientWidth + 5) {
      wrapper.classList.add("scroll-mode");   // left align
      wrapper.scrollLeft = 0;
    } else {
      wrapper.classList.remove("scroll-mode"); // center
    }
  }

  setTimeout(updateLayout, 200);
  window.addEventListener("resize", updateLayout);
});


});